<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <div *ngIf="state!='LIST'" class="secondary-toolbar-item selectable" (click)="showList()"><mat-icon>list</mat-icon> All Partners</div>
  <ng-container *ngIf="state=='EDIT'">
    <div class="secondary-toolbar-item"><mat-icon svgIcon="cw:action_next"></mat-icon>{{selectedPartner.name}}</div>
  </ng-container>
</mat-toolbar>

<section class="main-content">
  <cw-ci-admin-integration-partner-list #planList *ngIf="state=='LIST'" (stateChange)="onStateChange($event)" ></cw-ci-admin-integration-partner-list>
  <cw-ci-admin-integration-partner-edit *ngIf="state=='EDIT' || state=='CREATE'" (stateChange)="onStateChange($event)" [partner]="selectedPartner"></cw-ci-admin-integration-partner-edit>
</section>
